<div class="chat-container">
  <!-- Header -->
  <div class="chat-header">
    <div class="header-left">
      <div class="ai-avatar">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 8V4H8"/>
          <rect width="16" height="12" x="4" y="8" rx="2"/>
          <path d="M2 14h2"/>
          <path d="M20 14h2"/>
          <path d="M15 13v2"/>
          <path d="M9 13v2"/>
        </svg>
      </div>
      <div class="header-info">
        <span class="header-title">Knowledge Assistant</span>
        <span class="header-status">
          <span class="status-dot"></span>
          Online
        </span>
      </div>
    </div>
    <div class="header-actions">
      <button *ngIf="messages.length > 0" class="clear-btn" (click)="clearChat()" title="Nuova conversazione">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18"/>
          <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
          <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
        </svg>
      </button>
      <button class="close-btn" (click)="closeChat.emit()" aria-label="Close chat">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18"/>
          <path d="m6 6 12 12"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Messages Area -->
  <div class="chat-messages" #scrollContainer>
    <!-- Welcome message if no messages -->
    <div *ngIf="messages.length === 0" class="welcome-state">
      <div class="welcome-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      </div>
      <h3 class="welcome-title">How can I help you?</h3>
      <p class="welcome-text">Ask me anything about your knowledge base</p>
    </div>

    <!-- Messages -->
    <div *ngFor="let msg of messages; let i = index"
         class="message-wrapper"
         [class.user-message]="msg.role === 'user'"
         [class.assistant-message]="msg.role === 'assistant'"
         [style.animation-delay]="(i * 0.05) + 's'">

      <!-- Assistant Avatar -->
      <div *ngIf="msg.role === 'assistant'" class="message-avatar assistant-avatar">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 8V4H8"/>
          <rect width="16" height="12" x="4" y="8" rx="2"/>
          <path d="M2 14h2"/>
          <path d="M20 14h2"/>
          <path d="M15 13v2"/>
          <path d="M9 13v2"/>
        </svg>
      </div>

      <!-- Message Bubble -->
      <div class="message-bubble" [class.has-debug]="msg.debug">
        <!-- Debug button (appears on hover) -->
        <button *ngIf="msg.debug" class="debug-btn" (click)="openDebugModal(msg); $event.stopPropagation()" title="View agent reasoning">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m18 16 4-4-4-4"/><path d="m6 8-4 4 4 4"/><path d="m14.5 4-5 16"/>
          </svg>
        </button>
        <div class="message-content" [innerHTML]="msg.renderedHtml || msg.content"></div>

        <!-- Source Documents (clickable) -->
        <div *ngIf="msg.sources?.length" class="source-boxes">
          <div *ngFor="let src of msg.sources"
               class="source-box"
               (click)="openSourceDocument(src)">
            <div class="source-box-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/>
                <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
              </svg>
            </div>
            <div class="source-box-content">
              <span class="source-box-file">{{ src.file_name }}</span>
              <span class="source-box-snippet">{{ cleanSnippet(src.snippet) | slice:0:100 }}...</span>
            </div>
            <div class="source-box-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m9 18 6-6-6-6"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- Tools Used -->
        <div *ngIf="msg.toolsUsed?.length" class="message-sources">
          <span class="sources-label">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
            </svg>
            Tools
          </span>
          <div class="source-tags">
            <span *ngFor="let t of msg.toolsUsed" class="source-tag">{{ t }}</span>
          </div>
        </div>
      </div>

      <!-- User Avatar -->
      <div *ngIf="msg.role === 'user'" class="message-avatar user-avatar">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </div>
    </div>

    <!-- Typing Indicator -->
    <div *ngIf="isGenerating" class="message-wrapper assistant-message typing-wrapper">
      <div class="message-avatar assistant-avatar">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 8V4H8"/>
          <rect width="16" height="12" x="4" y="8" rx="2"/>
          <path d="M2 14h2"/>
          <path d="M20 14h2"/>
          <path d="M15 13v2"/>
          <path d="M9 13v2"/>
        </svg>
      </div>
      <div class="typing-indicator">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>

  <!-- Input Area -->
  <div class="chat-input-area">
    <div class="input-wrapper">
      <textarea
        class="chat-input"
        placeholder="Type your message..."
        [(ngModel)]="inputControl"
        (keydown)="handleKeydown($event)"
        [disabled]="isGenerating"
        rows="1"></textarea>
      <button
        class="send-btn"
        (click)="sendMessage()"
        [disabled]="!inputControl || isGenerating"
        [class.active]="inputControl && !isGenerating">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m22 2-7 20-4-9-9-4Z"/>
          <path d="M22 2 11 13"/>
        </svg>
      </button>
    </div>
    <span class="input-hint">Enter to send, Shift+Enter for new line</span>
  </div>
</div>

<!-- Debug Modal -->
<ng-template #debugModal let-modal>
  <div class="debug-modal">
    <div class="debug-modal-header">
      <h5>Agent Reasoning</h5>
      <div class="debug-header-actions">
        <button class="debug-copy-btn" (click)="copyDebug()" title="Copy to clipboard">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
          </svg>
          {{ debugCopied ? 'Copied!' : 'Copy' }}
        </button>
        <button class="debug-close-btn" (click)="modal.dismiss()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
        </svg>
      </button>
      </div>
    </div>

    <div class="debug-modal-body" *ngIf="activeDebug">
      <!-- Summary -->
      <div class="debug-summary">
        <div class="debug-stat">
          <span class="debug-stat-label">Model</span>
          <span class="debug-stat-value">{{ activeDebug.model }}</span>
        </div>
        <div class="debug-stat">
          <span class="debug-stat-label">Iterations</span>
          <span class="debug-stat-value">{{ activeDebug.total_iterations }}</span>
        </div>
        <div class="debug-stat">
          <span class="debug-stat-label">Input tokens</span>
          <span class="debug-stat-value">{{ activeDebug.total_tokens?.prompt_tokens | number }}</span>
        </div>
        <div class="debug-stat">
          <span class="debug-stat-label">Output tokens</span>
          <span class="debug-stat-value">{{ activeDebug.total_tokens?.completion_tokens | number }}</span>
        </div>
        <div class="debug-stat">
          <span class="debug-stat-label">Total tokens</span>
          <span class="debug-stat-value debug-stat-highlight">{{ activeDebug.total_tokens?.total_tokens | number }}</span>
        </div>
      </div>

      <!-- Conversation Context -->
      <div class="debug-section" *ngIf="activeDebug.history?.length">
        <div class="debug-section-title">Conversation Context ({{ activeDebug.history.length }} messages)</div>
        <div class="debug-history">
          <div *ngFor="let msg of activeDebug.history" class="debug-history-msg" [class.debug-history-user]="msg.role === 'user'" [class.debug-history-assistant]="msg.role === 'assistant'">
            <span class="debug-history-role">{{ msg.role }}</span>
            <span class="debug-history-content">{{ msg.content | slice:0:300 }}{{ msg.content.length > 300 ? '...' : '' }}</span>
          </div>
        </div>
      </div>

      <!-- Question -->
      <div class="debug-section">
        <div class="debug-section-title">Question</div>
        <div class="debug-code-block">{{ activeDebug.question }}</div>
      </div>

      <!-- Iterations -->
      <div class="debug-section" *ngFor="let iter of activeDebug.iterations">
        <div class="debug-section-title">
          <span class="debug-iter-badge" [class.debug-iter-final]="iter.type === 'final_answer'">
            Step {{ iter.iteration }}
          </span>
          <span class="debug-iter-type">{{ iter.type === 'tool_use' ? 'Tool Use' : 'Final Answer' }}</span>
          <span class="debug-iter-tokens" *ngIf="iter.tokens?.total_tokens">
            {{ iter.tokens.total_tokens | number }} tok
          </span>
        </div>

        <!-- Tool calls detail -->
        <div *ngIf="iter.tool_calls" class="debug-tools">
          <div *ngFor="let tc of iter.tool_calls" class="debug-tool-card">
            <div class="debug-tool-header">
              <span class="debug-tool-name">{{ tc.tool }}</span>
              <span class="debug-tool-args">{{ tc.args | json }}</span>
            </div>
            <div class="debug-tool-result">
              <pre>{{ tc.result }}</pre>
            </div>
          </div>
        </div>

        <!-- Evidence quotes parsed from response -->
        <div *ngIf="iter.evidence?.length" class="debug-evidence">
          <div class="debug-evidence-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/>
            </svg>
            Evidence Quotes ({{ iter.evidence.length }})
          </div>
          <div *ngFor="let ev of iter.evidence" class="debug-evidence-item">
            <span class="debug-evidence-file">{{ ev.file_name }}</span>
            <span class="debug-evidence-quote">{{ ev.quote }}</span>
          </div>
        </div>

        <div *ngIf="iter.type === 'final_answer' && (!iter.evidence || iter.evidence.length === 0)" class="debug-evidence-warning">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
            <path d="M12 9v4"/><path d="M12 17h.01"/>
          </svg>
          No evidence markers found in LLM response
        </div>

        <!-- Raw LLM output -->
        <details *ngIf="iter.raw_answer" class="debug-raw-details">
          <summary class="debug-raw-summary">Raw LLM Output</summary>
          <pre class="debug-raw-content">{{ iter.raw_answer }}</pre>
        </details>

        <!-- Final answer (cleaned) -->
        <div *ngIf="iter.answer" class="debug-code-block debug-answer-block">
          {{ iter.answer }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
